<div
  class="column column-input"
  [class.column-error]="hasErrors">
  <crm-standard-single-select
    class="w-full"
    styleClass="w-full"
    [descriptorApiUrl]="settingDropdownDescriptorApi"
    [additionalApiParams]="settingApiParams"
    [(selectedValue)]="settings.setting"
    (selectedValueChange)="onSettingChange()"
    [isError]="$any(errors?.setting)"></crm-standard-single-select>

  @if (errors?.setting) {
    <small class="p-error">
      {{ errors.setting | join }}
    </small>
  }
</div>

<div
  class="column column-input"
  [class.column-error]="hasErrors"
  [class.column-input-empty-message]="!settings.setting?.dimension">
  @if (settings.setting?.dimension) {
    <crm-standard-multi-select
      class="w-full"
      styleClass="w-full"
      [descriptorApiUrl]="dropdownDescriptorApis[settings.setting.dimension]"
      [additionalApiParams]="valueApiParams"
      [selectedValues]="getSelectedValues(settings.setting.dimension)"
      (selectedValuesChange)="setSelectedValues(settings.setting.dimension, $event)"
      [isError]="$any(getValuesErrors(settings.setting.dimension))"></crm-standard-multi-select>
    @if (getValuesErrors(settings.setting.dimension)) {
      <small class="p-error">
        {{ getValuesErrors(settings.setting.dimension) | join }}
      </small>
    }
  } @else {
    <span class="font-light">Выберите субконто</span>
  }
</div>

<div
  class="column column-remove-button"
  [class.column-error]="hasErrors">
  <i
    class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"
    pTooltip="Удалить строку"
    [showDelay]="500"
    tooltipPosition="top"
    style="font-size: 1.3rem"
    (click)="onDeleteClick.emit()"></i>
</div>
